import * as React from 'react';
import { Link } from 'react-router-dom';
import { User } from '../types/User';

interface Props {
  logout: () => void;
  user: User | null;
  children?: any;
}

const Header: React.SFC<Props> = (props: Props) => {
  const { logout, user } = props;
  const logo: string =
    require('../images/Ferritico_wordmark_Blue_final.svg').default;
  return (
    <header className="app-header">
      <div className="app-container app-header__inner">
        <Link to="/dashboard" className="brand" aria-label="Ferritico Home">
          <img src={logo} alt="Ferritico" width={140} />
        </Link>

        <div className="header-actions">
          {user && (
            <span className="chip" title={user.email}>
              {user.email}
            </span>
          )}
          {user && (
            <>
              <button className="btn ghost logout--desktop" onClick={logout}>
                Log out
              </button>
              <button className="btn ghost icon logout--mobile" onClick={logout} aria-label="Log out">
                <img src={require('../images/logout.svg').default} alt="" aria-hidden="true" />
              </button>
            </>
          )}
        </div>
      </div>

    </header>
  );
};

export default Header;
